import { render, staticRenderFns } from "./NotificationTemplatesForm.vue?vue&type=template&id=6d67b40c&scoped=true&"
import script from "./NotificationTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplatesForm.vue?vue&type=style&index=0&id=6d67b40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67b40c",
  null
  
)

export default component.exports